import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import GitHubIcon from "@material-ui/icons/GitHub";
import InstagramIcon from "@material-ui/icons/Instagram";

const useStyles = makeStyles(() => ({
  avatar: {
    height: 60,
    width: 60,
    marginBottom: 10,
  },
}));

export const StyledAvatar = ({ name, gitHubUrl, instaUrl, imgUrl }) => {
  const classes = useStyles();
  const openLink = (url) => {
    window.open(url, "_blank").focus();
  };

  return (
    <Grid item style={{ marginRight: 10 }}>
      <Avatar src={imgUrl} className={classes.avatar} />
      <Typography style={{ fontSize: "smaller" }} color="primary">
        {name}
      </Typography>
      <Grid container>
        <GitHubIcon
          fontSize="small"
          color="secondary"
          style={{ marginRight: 10 }}
          onClick={() => openLink(gitHubUrl)}
        />
        <InstagramIcon
          fontSize="small"
          color="secondary"
          onClick={() => openLink(instaUrl)}
        />
      </Grid>
    </Grid>
  );
};
